import React from 'react';
import { Close, DragIndicator } from '@mui/icons-material';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CircularCounter from './CircularCounter';
import RouteChip from './RouteChip';

const RouteStopListItem = ({ id, isDonor, onRemove, label = '', counter = 0 }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  return (
    <Box
      ref={setNodeRef}
      sx={{ mx: 2, mb: 1, transition, transform: CSS.Transform.toString(transform), opacity: isDragging ? 0.5 : 1 }}
    >
      <Paper elevation={25} sx={{ px: 2, py: 1, borderRadius: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <DragIndicator
            fontSize="small"
            sx={{
              flexShrink: 0,
              color: 'text.disabled',
              cursor: 'grab',
              '&:focus': {
                outline: 'none',
              },
              '&.Mui-focusVisible': {
                outline: 'none',
                backgroundColor: 'transparent',
              },
            }}
            {...attributes}
            {...listeners}
          />
          <CircularCounter showPrimaryColor={isDonor} counter={counter} />
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              userSelect: 'none',
            }}
          >
            {label}
          </Typography>
          <RouteChip isDonor={isDonor} />
          <IconButton size="small" onClick={onRemove} sx={{ flexShrink: 0, color: 'text.disabled' }}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </Paper>
    </Box>
  );
};

export default RouteStopListItem;
